import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_UPDATE_SALVAGE_VALUE = `${VEHICLE_MODULE_PREFIX}_UPDATE_SALVAGE_VALUE`;
export const onUpdateVehicleSalvageValueAction = (payload) => ({
    type: VEHICLE_UPDATE_SALVAGE_VALUE,
    payload
});
//# sourceMappingURL=updateSalvageValueAction.js.map